import { subRoles, subRolesCheckbox } from "../../../utils/constants";
import React from "react";
import { useParams } from "react-router-dom";
import { HiOutlineMail } from "react-icons/hi";
import { t } from "i18next";

export const PrincipalUserForms = ({ user }) => {
  const { id } = useParams();

  const {
    info: { firstname, lastname, genre, phone },
    email,
  } = user;

  return [
    {
      parentLabel: "",
      children: [
        {
          label: "Nom",
          name: "info.lastname",
          value: lastname,
          type: "input",
          required: true,
          col: 24,
        },
        {
          label: "Prénom",
          name: "info.firstname",
          value: firstname,
          required: true,
          type: "input",
          col: 24,
        },

        {
          label: "Genre",
          name: "info.genre",
          value: genre,
          required: true,
          type: "select",
          selectContent: [
            { label: t("prestationInputs.male"), value: "male" },
            { label: t("prestationInputs.female"), value: "female" },
          ],
          col: 24,
        },
        {
          label: "Email",
          name: "email",
          value: email,
          normalize: value => value && value.toLowerCase(),
          addonBefore: <HiOutlineMail />,
          type: "email",
          required: true,
          col: 24,
        },
        {
          label: "Téléphone",
          name: "info.phone",
          value: phone,
          type: "input",
          col: 24,
        },
      ],
    },
    {
      parentLabel: "Roles",
      children: [
        {
          label: "",
          name: "subRoles",
          value: user.subRoles,
          type: "checkbox",
          defaultEmpty: [],
          checkboxs: subRolesCheckbox(),
          col: 24,
        },
      ],
    },
    {
      children: [
        {
          label: id === "new" ? "Créer l'utilisateur" : "Sauvegarder",
          name: "send",
          value: "send",
          type: "submit",
          col: 24,
          align: "right",
        },
      ],
    },
  ];
};
